define('common/ko/fn/equals',['knockout', 'underscore', 'common/tools'], function(ko, _, tools) {
    ko.subscribable.fn.equals = _.memoize(function(value, equalityChecker) {
        equalityChecker = equalityChecker || _.isEqual;
        var self = this;
        return ko.pureComputed(function() {
            return equalityChecker(self(), ko.unwrap(value));
        });
    }, function(value, equalityChecker) { return tools.objToHash([this, value, equalityChecker]); } );
});
